import { useQuery } from "react-query";
import { api } from "../api";

export const useIncrementCounter = () => {
  return useQuery(["count"], () => api.incrementCount(), {
    staleTime: 100000,
    refetchOnMount: "always",
  });
};
